import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';

import type { RootState, AppDispatch } from '@/store';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export * from './useWindowsDimensions';
export * from './useNerisContext';
export * from './useGoogleMapsPlacesReady';
export * from './useNerisStationAssignment';
